/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';

function FollowersList(props) {
    return (
        <ul className="list-unstyled">
            {props.followers.map((item) => (
                <li key={`${item.first_name} ${item.last_name}`}>{`${item.first_name} ${item.last_name}`}</li>
            ))}
        </ul>
    );
}

FollowersList.propTypes = {
    followers: PropTypes.arrayOf(
        PropTypes.shape({
            first_name: PropTypes.string,
            last_name: PropTypes.string,
        }),
    ),
};

FollowersList.defaultProps = {
    followers: [],
};

export default FollowersList;
